import { render, staticRenderFns } from "./ModattaBusinessValueGenerated.vue?vue&type=template&id=d95f1166"
import script from "./ModattaBusinessValueGenerated.vue?vue&type=script&lang=js"
export * from "./ModattaBusinessValueGenerated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports